import { phpJsonString } from './php-json-values';
import { readItemUuidSlot } from './inventory-raw-readers';
import type { ItemFieldRow } from './item-field-reader';

function arrayLike(value: unknown): value is ItemFieldRow { return value !== null && typeof value === 'object'; }
function has(value: unknown, key: string): boolean { return arrayLike(value) && Object.prototype.hasOwnProperty.call(value, key); }
function own(value: unknown, key: string): unknown { return has(value, key) ? (value as Readonly<Record<string, unknown>>)[key] : undefined; }
const trim = (value: string): string => value.replace(/^[\x00\x09\x0A\x0B\x0D\x20]+|[\x00\x09\x0A\x0B\x0D\x20]+(?![\s\S])/g, '');

export function readLayerScoringToken(value: unknown): string | null {
    let token: unknown;
    if (typeof value === 'string' || typeof value === 'number') token = value;
    else if (has(value, 'item_layer_effect')) token = own(value, 'item_layer_effect');
    else {
        const first = own(value, '0');
        if (typeof first !== 'string' && typeof first !== 'number') return null;
        token = first;
    }
    return trim(phpJsonString(token)) || null;
}

export function readItemScalarLayerSlot(value: unknown): string {
    if (arrayLike(value)) return readItemUuidSlot(value) || readLayerScoringToken(value) || '';
    return typeof value === 'string' || typeof value === 'number' ? phpJsonString(value) : '';
}

export function readOverrideEntryAbilityId(value: unknown): string {
    if (!arrayLike(value)) return typeof value === 'string' ? value : '';
    const ability = own(value, 'ability_id');
    return typeof ability === 'string' && ability !== '' ? ability : readItemScalarLayerSlot(value);
}

/** Raw _ft_node_item_id; intentionally bypasses item_field's computed/instance bridges. */
export function readNodeItemId(row: ItemFieldRow | null): string | null {
    let value = own(own(row, 'items'), 'item_id') ?? own(row, 'item_id');
    if (arrayLike(value)) value = own(value, '0');
    return value == null || value === '' ? null : phpJsonString(value);
}
